import Axious from './api';
import { AxiosRequestConfig } from 'axios';
import { IOrderRequest } from '../utils/interfaces';

class TaggerService {
  /**
   * @param customerId customer alpha ID
   * @param orderId order Alpha Id
   */
  public async getOrderByAlphaCode(customerId: string = '', orderId: string = '') {
    const requestOptions: AxiosRequestConfig = {
      method: 'GET',
      url: `/customers/${customerId.toUpperCase()}/orders/${orderId.toUpperCase()}`,
    };
    return await Axious.request<IOrderRequest>(requestOptions);
  }
}

const taggerService = new TaggerService();

// export as singleton
export default taggerService;
